import Vue from 'vue';
import VueRouter from 'vue-router';
import Notify from '@/pages/Notify/Notify.vue';
import Campaigns from '@/pages/Campaigns/Campaigns.vue';
import CheckIn from '@/pages/CheckIn/CheckIn.vue';
import Product from '@/pages/Product/Product.vue';
import CreditsDetail from '@/pages/CreditsDetail/CreditsDetail.vue';
import Shop from '@/pages/Shop/Shop.vue';
import BoostCards from '@/pages/BoostCards/BoostCards.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/notify',
    name: 'notigy',
    component: Notify,
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    component: Campaigns,
  },
  {
    path: '/checkin',
    name: 'checkin',
    component: CheckIn,
  },
  {
    path: '/credits_detail',
    name: 'credits_detail',
    component: CreditsDetail,
  },
  {
    path: '/shop',
    name: 'shop',
    component: Shop,
  },
  {
    path: '/boost_cards',
    name: 'boost_cards',
    component: BoostCards,
  },
  {
    path: '/product_detail',
    name: 'product_detail',
    component: Product,
  },
];

const router = new VueRouter({
  base: '/app',
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  next();
})

export default router;


